import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import PhoneInput from '@profile-ui/react-phone-input-2';
import { useLocale } from '@adsk/alloy-react-locale';
import PhoneInputStyled from './styles';

const PhoneNumberInput = ({ onChange, value, error, testId, disabled }) => {
  const { T, locale: lang } = useLocale(({ locale }) =>
    require(`./i18n/${locale}.json`)
  );

  const localization = useMemo(() => {
    try {
      return require(`@profile-ui/react-phone-input-2/lang/${lang}.json`);
    } catch {
      return false;
    }
  }, [lang]);

  return (
    <PhoneInputStyled>
      <PhoneInput
        containerClass={error && 'react-tel-input--error'}
        country="us"
        disableSearchIcon
        enableSearch
        excludeCountries={['ir', 'cu', 'kp', 'sd', 'sy']}
        inputProps={{
          'data-testid': testId,
          'type': 'text',
        }}
        disabled={disabled}
        localization={localization}
        onChange={onChange}
        placeholder="0 (000) 000-0000"
        preserveOrder={['onlyCountries', 'preferredCountries']}
        searchNotFound={T.translate(
          'LICENSE_TRIAL_MARKETING_CARD_PHONE_NOT_FOUND'
        )}
        searchPlaceholder={T.translate(
          'LICENSE_TRIAL_MARKETING_CARD_PHONE_SEARCH'
        )}
        value={value}
      />
    </PhoneInputStyled>
  );
};

PhoneNumberInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.bool,
  testId: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
};

PhoneNumberInput.defaultProps = {
  onChange: () => undefined,
  value: '',
  error: false,
  testId: '',
};

export default PhoneNumberInput;
